import './styles.scoped.css'
import {Typography, TextField, FormControl, Select, MenuItem, Button, IconButton} from '@mui/material'
import {usStates} from '../../../../utils/helpers'
import {Controller} from 'react-hook-form'
import {Add, Delete} from '@mui/icons-material'
import {useFieldArray} from 'react-hook-form'
import {AddressAutocompleteField} from '../../../../components'

export default ({form}) => {
    const {
        fields: primaryPhoneNumberFields,
        append: appendPrimaryPhoneNumber,
        remove: removePrimaryPhoneNumber,
    } = useFieldArray({control: form?.control, name: 'primaryPhoneNumbers'})
    const {
        fields: primaryEmailAddressFields,
        append: appendPrimaryEmailAddress,
        remove: removePrimaryEmailAddress,
    } = useFieldArray({control: form?.control, name: 'primaryEmailAddresses'})
    const primaryPhoneNumberTypes = [
        {key: 'mobile', value: 'Mobile'},
        {key: 'work', value: 'Work'},
        {key: 'home', value: 'Home'},
    ]
    const primaryEmailAddressTypes = [
        {key: 'personal', value: 'Personal'},
        {key: 'work', value: 'Work'},
    ]
    const referralSources = ['Friends', 'Family', 'University', 'Physician', 'Insurance Provider']

    const selectEmergencyAddress = selected => {
        form.setValue('emergencyAddressStreetAddressLine2', '')
        form.setValue('emergencyAddressCity', selected?.city)
        form.setValue('emergencyAddressState', selected?.state)
        form.setValue('emergencyAddressZipCode', selected?.postcode)
    }

    return (
        <>
            <Typography variant="overline" color="text.secondary">
                CLIENT CONTACT
            </Typography>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Phone Number{' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </Typography>
            <div className="form">
                <FormControl style={{minWidth: 155}}>
                    <Controller
                        {...form.register(`primaryPhoneNumberType`)}
                        control={form.control}
                        render={({field}) => (
                            <Select
                                {...field}
                                value={field.value ?? 'mobile'}
                                onChange={e => field.onChange(e.target.value)}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}>
                                {primaryPhoneNumberTypes.map(item => (
                                    <MenuItem key={item?.key} value={item?.key}>
                                        {item?.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
                <TextField
                    placeholder="Enter your phone number"
                    fullWidth
                    {...form.register('primaryPhoneNumber')}
                    error={!!form.formState.errors['primaryPhoneNumber']}
                    helperText={form.formState.errors['primaryPhoneNumber']?.message}
                />
            </div>
            {primaryPhoneNumberFields.map((field, index) => (
                <div key={field.id} style={{marginTop: -14}}>
                    <br />
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Phone Number
                    </Typography>
                    <div className="form">
                        <FormControl style={{minWidth: 155}}>
                            <Controller
                                {...form.register(`primaryPhoneNumbers.${index}.type`)}
                                control={form.control}
                                render={({field}) => (
                                    <Select
                                        {...field}
                                        value={field.value ?? 'mobile'}
                                        onChange={e => field.onChange(e.target.value)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}>
                                        {primaryPhoneNumberTypes.map(item => (
                                            <MenuItem key={item?.key} value={item?.key}>
                                                {item?.value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                        <TextField
                            placeholder="Enter your phone number"
                            fullWidth
                            {...form.register(`primaryPhoneNumbers.${index}.number`)}
                            error={!!form.formState.errors?.primaryPhoneNumbers?.[index]?.number}
                            helperText={form.formState.errors?.primaryPhoneNumbers?.[index]?.number?.message}
                        />
                        <IconButton onClick={() => removePrimaryPhoneNumber(index)}>
                            <Delete color="error" />
                        </IconButton>
                    </div>
                </div>
            ))}
            <br />
            <br />
            <Button variant="text" startIcon={<Add />} onClick={() => appendPrimaryPhoneNumber({value: ''})}>
                Add Phone Number
            </Button>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Email Address{' '}
                <Typography variant="inputLabel" color="error">
                    *
                </Typography>
            </Typography>
            <div className="form">
                <FormControl style={{minWidth: 155}}>
                    <Controller
                        {...form.register(`primaryEmailAddressType`)}
                        control={form.control}
                        render={({field}) => (
                            <Select
                                {...field}
                                value={field.value ?? 'personal'}
                                onChange={e => field.onChange(e.target.value)}
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            maxHeight: 300,
                                        },
                                    },
                                }}>
                                {primaryEmailAddressTypes.map(item => (
                                    <MenuItem key={item?.key} value={item?.key}>
                                        {item?.value}
                                    </MenuItem>
                                ))}
                            </Select>
                        )}
                    />
                </FormControl>
                <TextField
                    placeholder="Enter your email address"
                    fullWidth
                    {...form.register('primaryEmailAddress')}
                    error={!!form.formState.errors['primaryEmailAddress']}
                    helperText={form.formState.errors['primaryEmailAddress']?.message}
                />
            </div>
            {primaryEmailAddressFields.map((field, index) => (
                <div key={field.id} style={{marginTop: -14}}>
                    <br />
                    <br />
                    <Typography variant="inputLabel" color="text.secondary">
                        Email Address
                    </Typography>
                    <div className="form">
                        <FormControl style={{minWidth: 155}}>
                            <Controller
                                {...form.register(`primaryEmailAddresses.${index}.type`)}
                                control={form.control}
                                render={({field}) => (
                                    <Select
                                        {...field}
                                        value={field.value ?? 'personal'}
                                        onChange={e => field.onChange(e.target.value)}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 300,
                                                },
                                            },
                                        }}>
                                        {primaryEmailAddressTypes.map(item => (
                                            <MenuItem key={item?.key} value={item?.key}>
                                                {item?.value}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                )}
                            />
                        </FormControl>
                        <TextField
                            placeholder="Enter your email address"
                            fullWidth
                            {...form.register(`primaryEmailAddresses.${index}.email`)}
                            error={!!form.formState.errors?.primaryEmailAddresses?.[index]?.email}
                            helperText={form.formState.errors?.primaryEmailAddresses?.[index]?.email?.message}
                        />
                        <IconButton onClick={() => removePrimaryEmailAddress(index)}>
                            <Delete color="error" />
                        </IconButton>
                    </div>
                </div>
            ))}
            <br />
            <br />
            <Button variant="text" startIcon={<Add />} onClick={() => appendPrimaryEmailAddress({value: ''})}>
                Add Email
            </Button>
            <br />
            <hr className="line" />
            <br />
            <Typography variant="overline" color="text.secondary">
                EMERGENCY CONTACT
            </Typography>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Name
            </Typography>
            <TextField placeholder="Enter your name" fullWidth {...form.register('emergencyName')} />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Phone Number
            </Typography>
            <TextField
                placeholder="Enter your phone number"
                fullWidth
                {...form.register('emergencyPhoneNumber')}
                error={!!form.formState.errors['emergencyPhoneNumber']}
                helperText={form.formState.errors['emergencyPhoneNumber']?.message}
            />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Email Address
            </Typography>
            <TextField
                placeholder="Enter your email address"
                fullWidth
                {...form.register('emergencyEmailAddress')}
                error={!!form.formState.errors['emergencyEmailAddress']}
                helperText={form.formState.errors['emergencyEmailAddress']?.message}
            />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Relationship
            </Typography>
            <TextField placeholder="Enter your relationship" fullWidth {...form.register('emergencyRelationship')} />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Street Address Line 1
            </Typography>
            <AddressAutocompleteField control={form.control} name="emergencyAddressStreetAddressLine1" onSelect={selectEmergencyAddress} />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Street Address Line 2
            </Typography>
            <TextField placeholder="Enter your street address line 2" fullWidth {...form.register('emergencyAddressStreetAddressLine2')} />
            <br />
            <br />
            <div className="form">
                <div className="form-left">
                    <Typography variant="inputLabel" color="text.secondary">
                        City
                    </Typography>
                    <TextField placeholder="Enter your city" fullWidth {...form.register('emergencyAddressCity')} />
                </div>
                <div className="form-right">
                    <Typography variant="inputLabel" color="text.secondary">
                        State
                    </Typography>
                    <FormControl fullWidth>
                        <Controller
                            {...form.register('emergencyAddressState')}
                            control={form.control}
                            render={({field}) => (
                                <Select
                                    {...field}
                                    value={field.value ?? ''}
                                    onChange={e => field.onChange(e.target.value)}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                    }}
                                    displayEmpty
                                    renderValue={selected => {
                                        if (selected === '') {
                                            return <span style={{color: '#aaa'}}>Select your state</span>
                                        }
                                        return selected
                                    }}>
                                    {usStates.map(item => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                </div>
            </div>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Zip Code
            </Typography>
            <TextField
                placeholder="Enter your zip code"
                fullWidth
                {...form.register('emergencyAddressZipCode')}
                error={!!form.formState.errors['emergencyAddressZipCode']}
                helperText={form.formState.errors['emergencyAddressZipCode']?.message}
            />
            <br />
            <br />
            <hr className="line" />
            <br />
            <Typography variant="overline" color="text.secondary">
                REFERRAL
            </Typography>
            <br />
            <br />
            <div className="form">
                <div className="form-left">
                    <Typography variant="inputLabel" color="text.secondary">
                        Referral Source
                    </Typography>
                    <FormControl fullWidth>
                        <Controller
                            {...form.register('referralSource')}
                            control={form.control}
                            render={({field}) => (
                                <Select
                                    {...field}
                                    value={field.value ?? ''}
                                    onChange={e => field.onChange(e.target.value)}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                maxHeight: 300,
                                            },
                                        },
                                    }}
                                    displayEmpty
                                    renderValue={selected => {
                                        if (selected === '') {
                                            return <span style={{color: '#aaa'}}>Select your referral source</span>
                                        }
                                        return selected
                                    }}>
                                    {referralSources.map(item => (
                                        <MenuItem key={item} value={item}>
                                            {item}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                </div>
                <div className="form-right">
                    <Typography variant="inputLabel" color="text.secondary">
                        Referral Person
                    </Typography>
                    <TextField placeholder="Enter your referral person" fullWidth {...form.register('referralPerson')} />
                </div>
            </div>
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Referral Email
            </Typography>
            <TextField
                placeholder="Enter your referral email"
                fullWidth
                {...form.register('referralEmail')}
                error={!!form.formState.errors['referralEmail']}
                helperText={form.formState.errors['referralEmail']?.message}
            />
            <br />
            <br />
            <Typography variant="inputLabel" color="text.secondary">
                Referral Phone Number
            </Typography>
            <TextField
                placeholder="Enter your referral phone number"
                fullWidth
                {...form.register('referralPhoneNumber')}
                error={!!form.formState.errors['referralPhoneNumber']}
                helperText={form.formState.errors['referralPhoneNumber']?.message}
            />
        </>
    )
}
